<template>
  <div class="relative">
    <input
      ref="input"
      v-bind="$attrs"
      :name="name"
      :type="type"
      :disabled="disabled || loading"
      :placeholder="placeholder"
      class="input"
      :class="classObject"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event)"
      @change="handleOnChange"
    />

    <Loader v-if="loading" label="" class="loading-icon" />

    <button v-if="retry" class="retry-button" @click="onRetryClick">
      <v-icon name="exclamation-circle" scale="1" class="retry-icon" /> Retry?
    </button>
  </div>
</template>

<script>
import Loader from "@/components/UI/Loader";

export default {
  name: "Input",
  components: { Loader },
  inheritAttrs: false,
  props: {
    inputClass: { default: "", type: String },
    disabled: {
      default: false,
      type: Boolean
    },
    loading: {
      default: false,
      type: Boolean
    },
    name: { default: "", type: String },
    onChange: {
      default: null,
      type: Function
    },
    placeholder: { default: "", type: String },
    retry: {
      default: false,
      type: Boolean
    },
    type: {
      default: "text",
      type: String
    },
    value: { default: "", type: [String, Number] }
  },
  data() {
    // Setup input css class names...
    const classObject = {
      loading: this.loading
    };
    if (this.inputClass) classObject[this.inputClass] = true;

    return {
      classObject
    };
  },
  methods: {
    handleOnChange(e) {
      if (this.onChange) this.onChange(e);
    },
    onRetryClick() {
      this.$emit("retry-click", this.$refs.input.value);
    }
  }
};
</script>

<style scoped>
.input {
  /* We're only setting font-size here and below in the md to overwrite typography.js injecting styles at the wrong point in the dom */
  font-size: 16px;

  &[disabled] {
    opacity: 0.6;
  }

  @screen md {
    @apply text-base;
  }
}

.loading-icon {
  @apply absolute p-0;
  font-size: 0.6rem;
  right: 15px;
  top: 16px;
}

.retry-button {
  @apply absolute text-danger bg-white;

  border-radius: 4px;
  border: 1px solid;
  font-size: 13px;
  padding: 2px 7px;
  right: 10px;
  top: 12px;

  &:hover {
    @apply text-white bg-danger;
  }

  &:focus {
    outline: none;
  }
}

.retry-icon {
  @apply relative;
  top: 2px;
}
</style>
